var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuKurs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2552_15106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83255 9.08333C7.94089 8.59167 7.33255 8.0875 7.33255 7.29583C7.33255 6.3875 8.17005 5.75 9.58255 5.75C11.0659 5.75 11.6159 6.45833 11.6659 7.5H13.5076C13.4534 6.0625 12.5742 4.75417 10.8326 4.325V2.5H8.33255V4.3C6.71589 4.65417 5.41589 5.69583 5.41589 7.30833C5.41589 9.23333 7.01172 10.1917 9.33255 10.75C11.4201 11.25 11.8326 11.9792 11.8326 12.7625C11.8326 13.3333 11.4284 14.25 9.58255 14.25C7.86589 14.25 7.18672 13.4792 7.09922 12.5H5.26172C5.36589 14.325 6.72839 15.3458 8.33255 15.6917V17.5H10.8326V15.7083C12.4534 15.3958 13.7492 14.4583 13.7492 12.7458C13.7492 10.3875 11.7242 9.57917 9.83255 9.08333V9.08333Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2552_15106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuKurs);
export default __webpack_public_path__ + "static/media/menu-kurs.dde5001dcceb1b46735d197dc45bf974.svg";
export { ForwardRef as ReactComponent };